import { Component, Input, OnInit, AfterContentChecked } from '@angular/core';
import { ActivatedRoute, Params, Router} from '@angular/router';
import { Location } from '@angular/common';
import { ContentService } from '../shared/content.service';
import { UtilsService } from '../shared/utils.service';
import { ConfigService } from '../shared/config.service';

const type: string = 'page';

@Component({
    template: require('./partials/content-pages.component.html'),
})
export class ContentPagesComponent implements OnInit, AfterContentChecked {
    
    public currentLanguage: string;
    public contents: any;

    constructor(public utils: UtilsService, private config: ConfigService, private contentService: ContentService, private route: ActivatedRoute, private location: Location, private router: Router) {
    }

    onStatusChange(status: any, item: any){
        item.active = status;
        this.contentService.saveContent(type, 'update', item).then(res =>{
            console.log("Content "+type+" set to "+status);
        });
    }

    public setContents(){
        this.route.params
            .switchMap((params: Params) => this.contentService.getContents(type, true)) // no cache
            .subscribe(response => {
                this.contents = response;
            });
    }

    public deleteContent(type: string, id: string){
        this.contentService.deleteContent(type,id);
        this.router.navigate(['pages/reload'], {relativeTo: this.route.parent});
        setTimeout(() => {
            this.router.navigate(['pages'], {relativeTo: this.route.parent});
        }, 500);  
    }

    ngOnInit(){
        this.setContents();
        this.route.parent.params.subscribe(
            (params: Params) => {
                this.currentLanguage = params['lg'];
            }
        );
    }
    ngAfterContentChecked(){
        if(!this.currentLanguage)
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-pages.component.ts